/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { date } from 'xrk-tools';

export default [
  {
    width: 180,
    tip: '请输入文件名称',
    label: '文件名称',
    key: 'fileName',
    id: 'fileName',
    slot: 'input'
  },
  // {
  //   width: 180,
  //   tip: '请输入操作者',
  //   label: '操作者',
  //   key: 'operatorName',
  //   id: 'operatorName',
  //   slot: 'input'
  // },
  {
    width: 180,
    id: 'monthrange',
    tip: '请选择下载时间',
    label: '下载时间',
    required: false,
    slot: 'daterange',
    val: [
      date.dateFormat(new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 'Y-M-D'),
      date.dateFormat(new Date(), 'Y-M-D')
    ],
    format: 'yyyy-MM-dd',
    rangeValue: [],
    key: ['startDate', 'endDate']
  }
];
